export const pipelinesAppId = 'PipelineApp'
